import { useMemo } from 'react';

import { useDocumentsUrlsQuery } from '@/modules/employee/Employee/Documents/queries';

import { LettersOfMedicalNecessity } from '../LettersOfMedicalNecessity.types';

const useGetPreviewForLMNs = (lmns: LettersOfMedicalNecessity[]) => {
  const ids = useMemo<string[]>(() => {
    return lmns.reduce((result: string[], item) => {
      if (item.documentId) {
        return [...result, item.documentId];
      }
      return result;
    }, []);
  }, [lmns]);
  const { isLoading, valuesMap } = useDocumentsUrlsQuery(ids);
  return {
    isLoading,
    valuesMap,
  };
};

export default useGetPreviewForLMNs;
